// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__MsE7Z","item":"Navigation_item__PQCMi"};